<template>
  <div size="md" @click="login">
    <slot></slot>

    <modal-wrapper
      v-if="isThirdPartyLoginShow && !$device.isMobile"
      :is-modal-wrapper-show="isThirdPartyLoginShow"
      :is-show-transition="true"
      :click-to-close="false"
      @close="loginWithThirdParty"
    >
      <ThirdPartyLogin
        v-if="isThirdPartyLoginShow"
        :details="details"
        @pass-screenshot="loginWithThirdParty"
        @close-thirdparty-login="isThirdPartyLoginShow = false"
        @click.native.stop=""
      ></ThirdPartyLogin>
    </modal-wrapper>
    <template v-if="$device.isMobile">
      <mounting-portal mount-to="#modal-wrapper" append>
        <transition name="slide-left">
          <ThirdPartyLogin
            v-if="isThirdPartyLoginShow"
            :details="details"
            class="room-info"
            @pass-screenshot="loginWithThirdParty"
            @close-thirdparty-login="isThirdPartyLoginShow = false"
          ></ThirdPartyLogin>
        </transition>
      </mounting-portal>
    </template>
  </div>
</template>

<script>
import ThirdPartyLogin from '@/views/Login/ThirdPartyLogin.vue';
import ModalWrapper from '@/components/Base/ModalWrapper.vue';
import fbTrack from '@/lib/base/fbTrack';
import BackEvent from '@/lib/base/backEvent.js';
import delay from '@/lib/base/delay';

export default {
  components: {
    ModalWrapper,
    ThirdPartyLogin,
  },
  data() {
    return {isThirdPartyLoginShow: false, details: null};
  },
  computed: {
    locale() {
      return this.$store.state.env.locale;
    },
  },
  methods: {
    getRedirectData() {
      try {
        const next = this.$route.query.next;
        return JSON.parse(next);
      } catch {
        return {};
      }
    },
    async login() {
      this.$store.commit('env/setIsLoading', true);
      try {
        await this.loginUser();
        this.$store.commit('env/setIsLoading', false);
      } catch (e) {
        this.$store.commit('env/setIsLoading', false);
        this.$Message.error(this.$t('登入失敗'));
      }
    },
    async loginUser() {
      const platform = 'guest';
      const {data} = await this.$store.dispatch('user/thirdPartyLogin', {
        platform,
        options: {language: this.locale},
      });
      fbTrack('CompleteRegistration');
      this.$gtmTrack('gtmCompleteRegistration');
      this.details = data;
      this.isThirdPartyLoginShow = true;
    },
    async loginWithThirdParty() {
      this.$store.commit('env/setIsLoading', true);
      await delay(100);
      BackEvent.popEvent();
      this.isThirdPartyLoginShow = false;
      this.$store.commit('user/setJwt', `Bearer ${this.details.token}`);
      await this.$store.dispatch('user/loginWithJwt');
      try {
        this.$JPush.updateTags();
      } catch (error) {
        console.error(error);
      }
      this.$store.commit('env/setIsLoading', false);
      const redirectData = {name: 'home', ...this.getRedirectData()};
      await this.$router.push(redirectData);
    },
  },
};
</script>
